const getRandomNum = () => {
  const array = new Uint32Array(1);
  window.crypto.getRandomValues(array);
  const randomNum = Math.floor((array[0] / 4294967295) * 90000 + 10000);
  return randomNum;
};

export { getRandomNum };
